<template>
  <div class="deleteRecordBox">
    <div class="filterContent">
      <!-- 头部筛选 -->
      <el-form :inline="true" :model="form">
        <!-- <el-form-item label="客户名称:">
          <el-input
            v-model="form.customer_name"
            :clearable="true"
            placeholder="请输入客户姓名"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="医生:" style="margin-bottom: 30px">
          <el-input
            v-model="form.doctor_name"
            :clearable="true"
            placeholder="请输入医生姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="医院:" style="margin-bottom: 30px">
          <el-input
            v-model="form.hospital_name"
            :clearable="true"
            placeholder="请输入医院名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="科室:" style="margin-bottom: 30px">
          <!-- <el-input
            v-model="form.dept_name"
            :clearable="true"
            placeholder="请输入科室名称"
          ></el-input> -->
          <el-select v-model="form.dept_name" clearable placeholder="请选择科室名称">
            <el-option
              v-for="item in departmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人:" style="margin-bottom: 30px">
          <el-input
            v-model="form.principal"
            :clearable="true"
            placeholder="请输入负责人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人ID:" style="margin-bottom: 30px">
          <el-input
            v-model="form.principal_userid"
            :clearable="true"
            placeholder="请输入负责人ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="删除方:" style="margin-bottom: 30px">
          <el-select v-model="form.del_side" clearable placeholder="请选择">
            <el-option
              v-for="item in delOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="删除日期:" style="margin-bottom: 30px">
          <el-date-picker
            unlink-panels
            class="release-select-time"
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="filterButton" type="primary" @click="onSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-form :inline="true" :model="form" style="margin-top: 30px">
        <el-form-item label="删除方:">
          <el-select v-model="form.del_side" clearable placeholder="请选择">
            <el-option
              v-for="item in delOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="删除日期:">
          <el-date-picker
            unlink-panels
            class="release-select-time"
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="filterButton" type="primary" @click="onSearch">搜索</el-button>
        </el-form-item>
      </el-form> -->
    </div>
    <div class="buttonList">
      <div class="leftContent">删除客户记录: 包括员工删除客户、客户删除员工的记录</div>
      <div class="rightContent">
        <ExportExcel
          :config-name="$options.name"
          :excel-data="excelData"
          :is-loading="isExportLoading"
          @emit="handleExportExcel"
        ></ExportExcel>
        <ExportProgress ref="downloadDialog"></ExportProgress>
      </div>
    </div>
    <!-- 表格 -->
    <div class="listContent">
      <el-table
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        header-row-class-name="headerClass"
        :header-cell-style="headerObj"
      >
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
        </template>
        <el-table-column prop="customer_name" label="客户名称"></el-table-column>
        <el-table-column prop="doctor_name" label="医生"></el-table-column>
        <el-table-column prop="hospital_name" label="医院" width="400"></el-table-column>
        <el-table-column prop="dept_name" label="科室"></el-table-column>
        <el-table-column prop="principal" label="负责人"></el-table-column>
        <el-table-column prop="principal_userid" label="负责人ID"></el-table-column>
        <el-table-column prop="del_side" label="删除方">
          <template slot-scope="scope">
            <span>{{ scope.row.del_side === 1 ? '员工' : '外部联系人' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="del_time" label="删除时间">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.del_time
                  ? dateFormat(new Date(scope.row.del_time), 'YYYY-MM-dd HH:mm:SS')
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="size"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time';
import { getContactDelRecordListApi } from '@/api/enterpriseWeChatManagement';
import NoData from '@/components/no-data';
import { getHospitalDepartmentListApi } from '@/api/setUp';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
export default {
  name: 'DeleteRecord',
  components: {
    NoData,
    ExportExcel,
    ExportProgress,
  },
  data() {
    return {
      dateFormat,
      headerObj: {
        background: '#f5f7fa',
      },
      delOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '外部联系人',
          value: 2,
        },
        {
          label: '员工',
          value: 1,
        },
      ],
      form: {
        // customer_name: '',
        doctor_name: '',
        principal: '',
        principal_userid: '',
        hospital_name: '',
        dept_name: '',
        del_side: '',
      },
      date: [],
      tableData: [],
      currentPage: 1 /* 当前页面数 */,
      size: this.g_pageSizeDefault /* 当前页面显示数目 */,
      total: 0 /* 总数 */,
      loading: false,
      excelData: [],
      isExportLoading: false,
      departmentOptions: [],
    };
  },
  created() {
    this.getTableData();
    this.getDepartmentList();
  },
  methods: {
    async getTableData() {
      this.loading = true;
      const params = {
        ...this.form,
        page: this.currentPage,
        limit: this.size || this.g_pageSizeDefault,
        del_start_time:
          this.date && this.date.length ? this.dateFormat(this.date[0], 'YYYY-MM-dd') : '',
        del_end_time:
          this.date && this.date.length ? this.dateFormat(this.date[1], 'YYYY-MM-dd') : '',
      };
      try {
        const res = await getContactDelRecordListApi(params);
        this.tableData = res.list;
        this.total = res.total;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
      }
      this.loading = false;
    },
    async getDepartmentList() {
      try {
        const res = await getHospitalDepartmentListApi({
          hospital_id: 0,
          page_index: 0,
          page_size: 0,
        });
        if (res.data && res.data.length) {
          this.departmentOptions = res.data.map((item) => ({
            label: item.department_name,
            value: item.department_name,
          }));
        }
      } catch (err) {
        console.log('error', err);
      }
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    /* 切换分页 */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.size = size;
      this.getTableData();
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);
      const params = {
        ...this.form,
        del_start_time: this.date.length ? this.dateFormat(this.date[0], 'YYYY-MM-dd') : '',
        del_end_time: this.date.length ? this.dateFormat(this.date[1], 'YYYY-MM-dd') : '',
      };
      try {
        const res = await getContactDelRecordListApi({
          page: 1,
          limit: 1,
          ...params,
        });
        if (res.total > 50000) {
          this.$message.warning(`最大支持导出5万条数据，当前数据${res.total}条，请重新筛选`);
          this.$refs.downloadDialog.abortProgress();
          this.isExportLoading = false;
        } else {
          const res = await getContactDelRecordListApi({
            page: 1,
            limit: 50000,
            ...params,
          });
          this.excelData = res.list.map((item) => {
            const items = { ...item };
            items.del_side = item.del_side === 1 ? '员工' : '外部联系人';
            items.del_time = item.del_time
              ? this.dateFormat(new Date(item.del_time.slice(0, -1)), 'YYYY-MM-dd HH:mm:SS')
              : '--';
            return items;
          });
          this.$refs.downloadDialog.finishProgress(500);
        }
      } catch (err) {
        this.$refs.downloadDialog.abortProgress();
        console.log('err', err);
      }
      this.isExportLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.deleteRecordBox {
  .filterContent {
    padding: 30px 0;
    border-bottom: 1px solid #eee;
    ::v-deep.el-form-item {
      margin-bottom: 0;
    }
  }
  .buttonList {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 16px 0;
    .leftContent {
      font-size: 16px;
      color: #313233;
    }
  }
  ::v-deep.pagination {
    text-align: right;
    margin: 10px 0;
  }
}
</style>
